import React, {PureComponent} from 'react';
import {Button, Col, Container, Row, Card, CardBody,} from 'reactstrap';
import MetricsGauge from './components/MetricsGauge';
import {connect} from 'react-redux';
import FtdsVsSignups from './components/FtdsVsSignups';
import LoadingProgress from '../../components/LoadingProgress'
import {fetchMainDashboardDataIfNeeded,
        main_dashbaord_hide_hello} from '../../redux/actions/MainDashboardActions';
import {fetchSalesDataIfNeeded} from '../../redux/actions/SalesActions'
import ReactQueryParams from 'react-query-params';
import ProvidersStat from '../../components/ProvidersStat'
import ProvidersTotal from "../../components/ProvidersTotal";
import {ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import MaterialTable from '../../components/table/material_table/MaterialTable'
import DateSelector from '../../components/DateSelector'
import SalesItems from '../sales/components/SalesItems';
import Modal from '../../components/Modal'

import * as TextManager from "../../modules/languages/TextManager";


class DefaultDashboard extends ReactQueryParams {

    constructor(props) {
        super(props);
        this.state = {
            dealTypeDetail: [],
            isFirst: true
        }
    }

    componentDidMount() {
        this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
        this.props.dispatch(fetchSalesDataIfNeeded());
    }

    getMetaForStoreTable = (obj) => {
        let res = {name: TextManager.getCurrentTextResource().Stores.stores, metrics: []};

        let filterNames = obj ? Object.getOwnPropertyNames(obj) : [];

        for (let indx in filterNames) {
            let col = filterNames[indx];

            let label = TextManager.getCurrentTextResource().Stores[col];
            res.metrics.push({
                id: col,
                label: label,
                numeric: false,
                disablePadding: true
            })
        }
        res.metrics.reverse();
        return res;
    };

    render() {

        let userType = undefined;
        let isManger = false;
        let isAdmin = false;
        if(this.props.userData && this.props.userData.data && this.props.userData.data.userType){

            userType = this.props.userData.data.userType;
            isManger = this.props.userData.data.isManger;
            isAdmin = this.props.userData.data.isAdmin;
        }

        return (
            <Container className='dashboard'>
                <style>
                    {`
                        .card-body {
                        box-shadow: 0 10px 30px 1px rgba(0, 0, 0, 0.06);
                        }
                    `}
                </style>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {/*this.props.isShow && this.props.userData && this.props.userData.data &&
                !this.props.userData.data.isAdmin && !this.props.userData.data.isManager &&
                <Modal color='success' title={TextManager.getCurrentTextResource().Text.hello} noCancel
                       message={this.props.userData.data.name}
                       approve={() => this.props.dispatch(main_dashbaord_hide_hello())}/>
                */}

                {this.props.status === 'success' &&
                <span>
                <Row>
                    <Col md={3} md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>{/*userType !== 5 && <span style={{marginRight: '15px', color: 'green'}}>מוקד התפעול לשירותך 0733998090 </span>*/}
                                    {TextManager.getCurrentTextResource().Text.dashboardName}</h3>
                                <div style={{display: 'flex', height: '100%', width: '50%'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                    <DateSelector endpoint='dashboard'/>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {this.props.salesStatus === 'success' &&
                <Row>
                    <Col md={12} lg={12}>
                        <SalesItems items={this.props.sales} />
                    </Col>
                </Row>}

                {userType !== 5 && <Row>
                    { this.props.userData && this.props.userData.data &&
                    (this.props.userData.data.isAdmin || this.props.userData.data.isManager) &&
                    <Col>
                        <MetricsGauge data={this.props.data.metrics} metricKey="activeStores"
                                      metricName={TextManager.getCurrentTextResource().Text.activeStores}/>
                    </Col>}

                    <Col>
                        <MetricsGauge data={this.props.data.metrics} metricKey="newUsers"
                                      metricName={TextManager.getCurrentTextResource().Text.newUsers}/>
                    </Col>
                    {(isManger || isAdmin || (userType && userType === 2)) &&
                    <Col>
                        <MetricsGauge data={this.props.data.metrics} metricKey="newLines"
                                      metricName={TextManager.getCurrentTextResource().Text.newLines}/>
                    </Col>}

                    { this.props.userData && this.props.userData.data &&
                    (this.props.userData.data.isAdmin || this.props.userData.data.isManager) &&
                     <Col>
                        <MetricsGauge data={this.props.data.metrics} metricKey="newStores"
                                      metricName={TextManager.getCurrentTextResource().Text.newStores}/>
                    </Col>}
                </Row>}
                {userType !== 5 && <Row>
                  <FtdsVsSignups data={this.props.data.metrics}/>
                </Row>}
                {userType !== 5 && <Row>
                    <ProvidersStat data={this.props.data.providers}/>
                    <ProvidersTotal data={this.props.data.providersTotal}/>
                </Row>}
                    {this.props.userData && (this.props.userData.data.isManager || this.props.userData.data.isAdmin) && userType !== 5 &&
                    <MaterialTable data={this.props.data.stores} noPaddingCard
                                   meta={this.getMetaForStoreTable(this.props.data.stores[0])}/>
                    }
              </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.mainDashboard.status,
        isShow: state.mainDashboard.isShow,
        data: state.mainDashboard.data,
        userData: state.userData,
        sales: state.sales.data,
        salesStatus: state.sales.status,
    };
};

export default withRouter(connect(mapStateToProps)(DefaultDashboard))